import { render, staticRenderFns } from "./GlobalSettingsItem.vue?vue&type=template&id=c19fc7f2&scoped=true&"
import script from "./GlobalSettingsItem.vue?vue&type=script&lang=js&"
export * from "./GlobalSettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSettingsItem.vue?vue&type=style&index=0&id=c19fc7f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19fc7f2",
  null
  
)

export default component.exports